export default __webpack_public_path__ + "static/media/Nicolas.353b19bc.jpg";